import { getErrorMessage } from '../../errorBuilder';
import { get, post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getAdminQueryList = async (ticketId, params) => {
  const builder = new UrlBuilder(`/manage/query/list/${ticketId}`);

  builder.add('page', params?.page || 1);
  builder.add('pageSize', params?.limit || 10);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const adminCreateQuery = async (payload) => {
  const builder = new UrlBuilder(`/manage/query/create`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const adminViewAttachment = async (payload) => {
  const builder = new UrlBuilder(`/manage/query/view-document`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const adminRemoveAttachment = async (payload) => {
  const builder = new UrlBuilder(`/manage/query/delete-document`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const adminCloseTicket = async (payload) => {
  const builder = new UrlBuilder(`/manage/tickets/close-ticket`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
